__turbopack_context__.v({
  "aura-breathe": "home-module-scss-module__L0NsKq__aura-breathe",
  "banner-drift": "home-module-scss-module__L0NsKq__banner-drift",
  "floor-drift": "home-module-scss-module__L0NsKq__floor-drift",
  "page": "home-module-scss-module__L0NsKq__page",
  "panel-float": "home-module-scss-module__L0NsKq__panel-float",
});
